// extracted by mini-css-extract-plugin
module.exports = {"Accessories":"Accessories_Accessories__LvVj2"};